import React, { Fragment } from 'react'
import {
  useDepartmentDetails,
  DepartmentDetailsProps,
} from './useDepartmentDetails'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import InnerTitleSection from 'components/InnerTitleSection/InnerTitleSection'
import Gallery from './Gallery/Gallery'
import Content from './Content/Content'
import RelatedNews from './RelatedNews/RelatedNews'
import NotFound from './NotFound/NotFound'
import Loader from 'components/Loader/Loader'

const DepartmentDetails: React.FC<DepartmentDetailsProps> = (
  props: DepartmentDetailsProps
) => {
  const { departmentDetails, isLoading } = useDepartmentDetails(props)

  const { i18n, t } = useCustomTranslation()
  const currentLanguage = i18n.language
  const isAr = currentLanguage === 'ar'

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <InnerTitleSection
        title={
          departmentDetails && departmentDetails.length
            ? isAr
              ? departmentDetails[0].nameAr
              : departmentDetails[0].nameEn
            : t('departmentDetails')
        }
        breadcrumbs={[
          {
            title: t('navHome'),
            link: `/${currentLanguage}`,
          },
          {
            title: t('navDepartments'),
            link: `/${currentLanguage}/Departments`,
          },
          {
            title: t('departmentDetails'),
          },
        ]}
      />
      {departmentDetails && departmentDetails.length ? (
        <Fragment>
          <Gallery />
          <Content isAr={isAr} t={t} />
          <RelatedNews isAr={isAr} t={t} />
        </Fragment>
      ) : (
        <NotFound message='No Data' />
      )}
    </main>
  )
}

export default DepartmentDetails
